<template>
  <div class="import-error-card-ui">
    <VCard class="error">
      <div class="import-error-card-ui__content">
        <div class="import-error-card-ui__head">
          <p class="import-error-card-ui__title">{{ errorMessage }}</p>
          <IconBtn
            :append-icon-class-name="`fr fr-chevron-${isDetailedView ? 'up' : 'down'}`"
            :label="`${isDetailedView ? 'Hide' : 'Show'} details`"
            variation-class-name="toggle error"
            btn-class-name="error"
            flat
            @click.capture.stop.prevent="toggleDetails"
          />
        </div>
        <transition @before-enter="start" @enter="end" @before-leave="end" @leave="start">
          <div v-show="isDetailedView" class="import-error-card-ui__details">
            <ul class="import-error-card-ui__details-list">
              <li v-for="error in list" :key="error.title" class="import-error-card-ui__error">
                <h3 class="import-error-card-ui__error-title">{{ error.title }}</h3>
                <ul class="import-error-card-ui__error-list">
                  <li
                    v-for="item in error.items"
                    :key="item"
                    class="import-error-card-ui__error-list-item"
                  >
                    - {{ item }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </transition>
      </div>
    </VCard>
  </div>
</template>

<script lang="ts" setup>
  // Types
  import type { TImportFormattedError } from '~/shared/import/types';

  // Components
  import VCard from '~/misc/v-card';
  import IconBtn from '~/misc/btn/icon/IconBtn.vue';

  const props = defineProps({
    message: {
      type: String,
      default: null,
    },
    list: {
      type: Array as PropType<TImportFormattedError[]>,
      required: true,
    },
  });

  const isDetailedView: Ref<boolean> = ref<boolean>(false);
  const errorMessage: Ref<string | null> = ref<string | null>(null);

  const setIsDetailedView = (state: boolean) => {
    isDetailedView.value = state;
  };

  const setErrorMessage = (message: string | null) => {
    errorMessage.value = message;
  };

  const toggleDetails = () => setIsDetailedView(!isDetailedView.value);

  const start = (el: Element) => {
    (el as HTMLElement).style.maxHeight = '0';
    (el as HTMLElement).style.opacity = '0';
  };

  const end = (el: Element) => {
    (el as HTMLElement).style.maxHeight = el.scrollHeight + 'px';
    (el as HTMLElement).style.opacity = '1';
  };

  watch(
    () => props.list,
    (data: TImportFormattedError[]) =>
      setErrorMessage(
        data.length ? `${data.length} error${data.length > 1 ? 's' : ''} detected.` : null
      ),
    { immediate: true }
  );
</script>
